// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"3c3b3bc3","184":"8ab02712","293":"f9e56540","317":"77b32364","473":"b99cfbe7","506":"0a8bf925","515":"7eed6708","531":"46096e93","555":"1bffc5b0","821":"c93d331e","910":"0d77f723","948":"b3e050fa","962":"4d537d9a"}[chunkId] + ".chunk.js";
};